// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.commutably {
  --tooltip-border-size: 2px;
  --tooltip-border-radius: 4px;
  --tooltip-transition-duration: var(--default-transition-duration);
  --tooltip-transition-timing: ease;
  --tooltip-min-width: 6em;
  --tooltip-max-width: 100vw;
  --tooltip-padding: 0.6em 1em;

  --tooltip-trigger-offset: 0.5em;
  --tooltip-arrow-size: 7px;

  --tooltip-paper1-background: white;
  --tooltip-paper1-color: black;

  --tooltip-paper2-background: var(--color-grey-5);
  --tooltip-paper2-color: white;

  --tooltip-inverse-background: black;
  --tooltip-inverse-color: white;

  --tooltip-info-background: var(--gradient-blue-1);
  --tooltip-info-color: white;

  --tooltip-accent-background: var(--gradient-purple-1);
  --tooltip-accent-color: white;

  --tooltip-success-background: var(--color-green-1);
  --tooltip-success-color: white;

  --tooltip-warn-background: var(--color-yellow-1);
  --tooltip-warn-color: black;

  --tooltip-error-background: var(--gradient-red-1);
  --tooltip-error-color: white;

  --tooltip-box-shadow: var(--shadow-2);
  --tooltip-elevated-box-shadow: var(--shadow-3);
}
`, "",{"version":3,"sources":["webpack://./src/theme/components/Tooltip.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,iEAAiE;EACjE,iCAAiC;EACjC,wBAAwB;EACxB,0BAA0B;EAC1B,4BAA4B;;EAE5B,+BAA+B;EAC/B,yBAAyB;;EAEzB,kCAAkC;EAClC,6BAA6B;;EAE7B,gDAAgD;EAChD,6BAA6B;;EAE7B,mCAAmC;EACnC,8BAA8B;;EAE9B,iDAAiD;EACjD,2BAA2B;;EAE3B,qDAAqD;EACrD,6BAA6B;;EAE7B,kDAAkD;EAClD,8BAA8B;;EAE9B,gDAAgD;EAChD,2BAA2B;;EAE3B,iDAAiD;EACjD,4BAA4B;;EAE5B,qCAAqC;EACrC,8CAA8C;AAChD","sourcesContent":[".commutably {\n  --tooltip-border-size: 2px;\n  --tooltip-border-radius: 4px;\n  --tooltip-transition-duration: var(--default-transition-duration);\n  --tooltip-transition-timing: ease;\n  --tooltip-min-width: 6em;\n  --tooltip-max-width: 100vw;\n  --tooltip-padding: 0.6em 1em;\n\n  --tooltip-trigger-offset: 0.5em;\n  --tooltip-arrow-size: 7px;\n\n  --tooltip-paper1-background: white;\n  --tooltip-paper1-color: black;\n\n  --tooltip-paper2-background: var(--color-grey-5);\n  --tooltip-paper2-color: white;\n\n  --tooltip-inverse-background: black;\n  --tooltip-inverse-color: white;\n\n  --tooltip-info-background: var(--gradient-blue-1);\n  --tooltip-info-color: white;\n\n  --tooltip-accent-background: var(--gradient-purple-1);\n  --tooltip-accent-color: white;\n\n  --tooltip-success-background: var(--color-green-1);\n  --tooltip-success-color: white;\n\n  --tooltip-warn-background: var(--color-yellow-1);\n  --tooltip-warn-color: black;\n\n  --tooltip-error-background: var(--gradient-red-1);\n  --tooltip-error-color: white;\n\n  --tooltip-box-shadow: var(--shadow-2);\n  --tooltip-elevated-box-shadow: var(--shadow-3);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
